/**
 * 中文语言包
 *
 * 结构说明：
 *   common    — 跨页面共用的文案（按钮、表格字段、证件类型、性别等）
 *   validate  — 表单验证提示
 *   request   — 网络请求错误
 *   header    — Header 组件
 *   footer    — Footer 组件
 *   index     — 首页（赛事轮播）
 *   login     — 登录页
 *   register  — 注册页
 *   home      — 主页（侧边栏菜单）
 *   teamInfo  — 队伍信息
 *   athleteInfo    — 运动员报名（含 API 字段标签映射）
 *   personInfo     — 随队官员管理
 *   personProject  — 个人项目申报
 *   trainProject   — 对练项目申报
 *   teamProject    — 集体项目申报
 *   projectSum     — 汇总信息及打印
 *   manager        — 管理员页面（代表队管理）
 *
 * 添加新条目时，同步更新 en.js 中对应的英文翻译。
 */
export default {
  common: {
    // 按钮 & 操作
    search: '搜索',
    reset: '重置',
    add: '添加',
    edit: '编辑',
    delete: '删除',
    confirm: '确认',         // 弹窗确认按钮
    cancel: '取消',          // 弹窗取消按钮
    ok: '确定',              // 表单提交按钮
    submit: '提交',
    view: '查看',
    download: '下载',
    moreBtn: '更多',
    enter: '进入',
    saveAndNext: '保存并下一步',

    // 表格列名
    serialNo: '序号',
    operation: '操作',

    // 表单字段
    name: '姓名',
    gender: '性别',
    age: '年龄',
    birthDate: '出生日期',
    group: '组别',
    item: '小项',
    contactPhone: '联系电话',
    contactEmail: '联系邮箱',
    certificateType: '证件类型',
    certificateNumber: '证件号码',
    headPhoto: '大头照',
    certificateFrontPhoto: '证件正面照',
    certificateBackPhoto: '证件反面照',
    function: '职能',
    project: '项目',
    athlete: '运动员',
    registrationForm: '报名表',
    voluntaryLiability: '自愿参赛责任书',

    // 性别枚举值
    male: '男',
    female: '女',

    // 证件类型枚举值（对应后端 certificateType 字段的数值）
    idCard: '身份证',
    drivingLicense: '驾照证',
    passport: '护照',
    militaryCard: '军人证',
    hkMacauId: '港澳身份证',
    taiwanPermit: '台胞证',
    other: '其他',

    // 项目分类
    individualProject: '个人项目',
    pairTrainingProject: '对练项目',
    groupProject: '集体项目',

    // 特殊标签
    trainingPartner: '陪练',
    substitute: '替补',
    comment: '备注',
    position: '职位',
    contact: '联系人',
    contactInfo: '联系方式',

    // 统计信息
    statistics: '统计信息',
    totalPeople: '总人数',
    maleAthlete: '男运动员',
    femaleAthlete: '女运动员',

    // 系统提示
    prompt: '提示',
    submittedLockTip: '报名已提交，不可修改，如需修改请联系管理员撤回',

    // 输入占位符
    pleaseInput: '请输入',
    pleaseInputKeyword: '请输入关键字',
    pleaseSelect: '请选择',
    autoGenerate: '自动生成',

    // 单位后缀
    people: '人',
    upload: '上传',
  },

  // 表单验证消息（computed ruleForm 中使用 this.$t() 动态读取）
  validate: {
    required: '请输入',
    requiredSelect: '请选择',
    formatIncorrect: '格式不正确',
    maxLength: '长度不能超过{max}个字符',
    teamNameFormat: '队伍名称不能包含空格和特殊字符',
  },

  // 网络请求错误（src/util/request.js 拦截器中使用）
  request: {
    error: '请求出错，请重试',
  },

  // === 以下为各页面/组件独有文案 ===

  header: {
    registerTime: '报名时间',
    logout: '退出',
  },

  footer: {
    browserTip: '建议您使用Edge、Chrome 80+、FireFox 86+、360极速模式等主流浏览器浏览本网站',
    copyright: 'Copyright ©️2025 佛山云体智慧科技有限公司版权所有 保留所有版权',
    icp: '粤ICP备2024267651号-1',
    moreInfo: '更多资讯：www.one-type.com',
  },

  index: {
    systemName: 'One-Type竞赛报名系统',
    registerTime: '报名时间',
    statusPending: '待开始',
    statusOpen: '报名中',
    statusClosed: '已结束',
    matchTime: '比赛时间',
    matchVenue: '比赛场地',
    warnNotStarted: '还未开始报名',
    warnEnded: '报名已结束',
  },

  login: {
    registerTime: '报名时间',
    userLogin: '用户登录',
    fileDownload: '文件下载',
    downloadFailed: '文件下载失败，请重试',
    specialNote: '特殊说明',
    account: '账号',
    password: '密码',
    placeholderAccount: '请输入账号',
    placeholderPassword: '请输入密码',
    login: '登录',
    backToIndex: '返回首页',
    goRegister: '去注册',
  },

  register: {
    registerTime: '报名时间',
    userRegister: '用户注册',
    account: '账号',
    password: '密码',
    mobilePhone: '手机号',
    placeholderAccount: '请输入账号',
    placeholderPassword: '请输入密码',
    placeholderMobile: '请输入手机号',
    registerAndLogin: '注册并登录',
    goLogin: '去登录',
  },

  home: {
    baseRegistration: '基础报名',
    teamInfo: '队伍信息',
    athleteRegistration: '运动员报名',
    teamOfficialMgmt: '随队官员管理',
    individualProject: '个人项目申报',
    pairTrainingProject: '对练项目申报',
    groupProject: '集体项目申报',
    summaryAndPrint: '汇总信息及打印',
    confirmLogout: '确认退出登录吗?',
    configNotComplete: '请先完成赛事表单配置',
    needCompleteTeamInfoFirst: '请先填写并保存队伍信息',
  },

  teamInfo: {
    title: '队伍信息',
    teamName: '代表队名称',
    contactName: '联系人姓名',
    contactPhone: '联系电话',
    contactEmail: '联系邮箱',
    memberUnit: '会员单位',
    region: '所在地区',
    placeholder: '请输入',
  },

  athleteInfo: {
    title: '运动员信息',
    addAthlete: '添加运动员',
    editAthlete: '编辑运动员',
    deleteConfirm: '确定删除该运动员吗？',
    needCertNumber: '请先填写证件号码',
    photoUploadFailed: '大头照上传失败',
    certFrontUploadFailed: '证件正面照上传失败',
    certBackUploadFailed: '证件反面照上传失败',
    customUploadFailed: '自定义上传{0}上传失败',  // {0} 会被替换为 1/2/3
    // API 表单配置中的字段标签（用于 el-table-column 等位置的固定中文标签）
    realNameCh: '姓名（中文）',
    realNameEn: '姓名（英文）',
    surnameCh: '姓氏（中文）',
    surnameEn: '姓氏（英文）',
    givenNameCh: '名字（中文）',
    givenNameEn: '名字（英文）',
  },

  personInfo: {
    title: '随队官员信息',
    addOfficial: '添加随队官员',
    editOfficial: '编辑随队官员',
    deleteConfirm: '确定删除该官员吗？',
    needCertNumber: '请先填写证件号码',
    photoUploadFailed: '大头照上传失败',
    certFrontUploadFailed: '证件正面照上传失败',
    certBackUploadFailed: '证件反面照上传失败',
    customUploadFailed: '自定义上传{0}上传失败',
    realNameCh: '姓名（中文）',
    realNameEn: '姓名（英文）',
    surnameCh: '姓氏（中文）',
    surnameEn: '姓氏（英文）',
    givenNameCh: '名字（中文）',
    givenNameEn: '名字（英文）',
  },

  personProject: {
    title: '个人项目申报',
    editProject: '编辑报项',
    pleaseEnterComment: '请填写项目备注',
  },

  trainProject: {
    title: '对练项目申报',
    editProject: '编辑报项',
    needSelectAthlete: '请选择运动员',
    pleaseEnterComment: '请输入备注',
    deleteConfirm: '确定删除该报项吗？',
  },

  teamProject: {
    title: '集体项目申报',
    editProject: '编辑报项',
    needSelectAthlete: '请选择运动员',
    pleaseEnterComment: '请填写项目备注',
    selectPosition: '请选择职位',
    pleaseSelectPosition: '请为已勾选的运动员选择职位',
  },

  projectSum: {
    teamInfo: '代表队信息',
    title: '汇总信息及打印',
    registrationForm: '报名表',
    athleteInfo: '运动员信息',
    officialInfo: '随队官员信息',
    uploadStampedForm: '上传盖章报名表',
    uploadVoluntaryLiability: '上传自愿参赛责任书',
    downloadForm: '下载报名表',
    onlyImageOrPdf: '只能上传图片或PDF文件!',
    needUploadForm: '请选上传报名表!',
    needUploadLiability: '请选上传自愿参赛责任书!',
    confirmSubmit: '确定提交报名吗？'
  },

  manager: {
    teamInfo: '代表队信息',
    registerTime: '报名时间',
    logout: '退出',
    placeholderTeamName: '请输入代表队名称',
    placeholderContactPhone: '请输入联系电话',
    placeholderStatus: '请选择提交状态',
    teamName: '代表队名称',
    contactName: '联系人姓名',
    contactPhone: '联系电话',
    contactEmail: '联系邮箱',
    memberUnitName: '会员单位',
    athleteCount: '运动员数',
    submitStatus: '提交状态',
    notSubmitted: '未提交',
    submitted: '已提交',
    submitTime: '提交时间',
    exportTeam: '导出代表队',
    exportAthlete: '导出运动员',
    exportOfficial: '导出随队官员',
    submit: '提交',
    reject: '退回',
    teamDetail: '代表队详情',
    confirmSubmit: '确定提交报名吗？',
    confirmReject: '确定退回吗？',
    confirmLogout: '确认退出登录吗?',
    athleteInfo: '运动员信息',
    officialInfo: '随队官员信息',
    downloadStampedForm: '盖章报名表',
    downloadLiability: '自愿参赛责任书',
    viewAccount: '查看账号密码',
    account: '账号',
    password: '密码',
    delTeam: '删除代表队',
    confirmDelTeam: '确定删除该代表队？其运动员、报项及随队官员信息将一并删除，且不可恢复',
  },
}
